import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKtmComponent } from './simple-icons-ktm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKtmComponent ],
    exports:      [ SimpleIconsKtmComponent ],
    bootstrap:    []
})
export class SimpleIconsKtmModule {}
